<template lang="pug">
#CreateEditForm
  b-form(@submit.stop.prevent="onSubmit", novalidate)
    b-row
      b-col(cols="6")
        b-form-group(id="input-group-name" label="Nombre" label-for="input-name")
          b-form-input(
            id="input-name" 
            v-model="form.name" 
            placeholder="Nombre"
            :state="$v.$dirty ? !$v.form.name.$invalid : null"
          )
        .errors(v-if="$v.$dirty")
          b-form-invalid-feedback(:state="$v.form.name.required") Campo requerido
      b-col(cols="6")
        b-form-group(id="input-group-razonSocial" label="Razon Social" label-for="input-razonSocial")
          b-form-input(
            id="input-razonSocial" 
            v-model="form.razonSocial" 
            placeholder="Razon Social"
            :state="$v.$dirty ? !$v.form.razonSocial.$invalid : null"
          )
          .errors(v-if="$v.$dirty")
            b-form-invalid-feedback(:state="$v.form.razonSocial.required") Campo requerido
    b-row
      b-col(cols="6")
        b-form-group(id="input-group-rut" label="RUT" label-for="input-rut")
          b-form-input(
            id="input-rut" 
            v-model="form.rut" 
            placeholder="RUT"
            :state="$v.$dirty ? !$v.form.rut.$invalid && rutIsValid : null"
            @input="formatRut"
            @change="formatRut"
          )
          .errors(v-if="$v.$dirty")
            b-form-invalid-feedback(:state="$v.form.rut.required") Campo requerido
            b-form-invalid-feedback(:state="rutIsValid") No es un rut valido
      b-col(cols="6")
        b-form-group(id="input-group-legalRepresentative" label="Representante Legal" label-for="input-legalRepresentative")
          b-form-input(
            id="input-legalRepresentative" 
            v-model="form.legalRepresentative" 
            placeholder="Representante Legal"
            :state="$v.$dirty ? !$v.form.legalRepresentative.$invalid : null"
          )
          .errors(v-if="$v.$dirty")
            b-form-invalid-feedback(:state="$v.form.legalRepresentative.required") Campo requerido
    b-row
      b-col(cols="6")
        b-form-group(id="input-group-startContract" label="Inicio Contrato" label-for="input-startContract")
          b-form-datepicker(
            id="input-startContract" 
            v-model="form.startContract" 
            locale="es-CL"
            :state="$v.$dirty ? !$v.form.startContract.$invalid : null"
          )
          .errors(v-if="$v.$dirty")
            b-form-invalid-feedback(:state="$v.form.startContract.required") Campo requerido
      b-col(cols="6")
        b-form-group(id="input-group-endContract" label="Fin Contrato" label-for="input-startContract")
          b-form-datepicker(
            id="input-endContract" 
            v-model="form.endContract" 
            locale="es-CL"
            :state="$v.$dirty ? !$v.form.endContract.$invalid : null"
          )
          .errors(v-if="$v.$dirty")
            b-form-invalid-feedback(:state="$v.form.endContract.required") Campo requerido
      b-col(cols="6")
        b-form-group(id="input-group-contact" label="Contacto" label-for="input-contact")
          VueTagsInput(
            v-model="contactTagValue"
            placeholder="Correos de Contacto"
            :tags="contactTags"
            :validation="contactTagValidations"
            @tags-changed="newTags => { contactTags = newTags; contactTagValue = '' }"
          )
          .errors(v-if="$v.$dirty")
            b-form-invalid-feedback(:state="$v.form.contact.required") Campo requerido
    .modal-footer
      b-button(
        @click="hideModal()",
        variant="outline-muted",
        v-if="action === 'create'"
      ) Cancelar
      b-button.btn-create(type="submit") {{action==='create'?'Crear':'Editar'}}
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'
import validateRut from '../../utils/validateRut'
import VueTagsInput from '@johmun/vue-tags-input'
import { emailValidator } from '../../shared/validations'
export default {
  props: [ "selectedBusiness", "action", "hideModal", "makeToast", "hideCancel"],
  components:{
    VueTagsInput
  },
  validations: {
    form: {
      name: { required },
      razonSocial: { required },
      rut: { required },
      startContract: { required },
      endContract: { required },
      legalRepresentative: { required },
      contact: { required }
    }
  },
  data() {
    return {
      contactTags: this.action === 'create' ? [] : this.selectedBusiness.contact.split(',').map(e => { return { text: e } }),
      contactTagValue: '',
      contactTagValidations: [
        {
          classes: 'avoid-item',
          rule: ({ text }) => !emailValidator(text)
        }
      ],
      form: {
        id: this.action === 'create' ? null : this.selectedBusiness.id,
        name: this.action === 'create' ? null : this.selectedBusiness.name,
        razonSocial: this.action === 'create' ? null : this.selectedBusiness.razonSocial,
        rut: this.action === 'create' ? null : this.selectedBusiness.rut,
        startContract: this.action === 'create' ? null : this.selectedBusiness.startContract,
        endContract: this.action === 'create' ? null : this.selectedBusiness.endContract,
        legalRepresentative: this.action === 'create' ? null : this.selectedBusiness.legalRepresentative,
        contact: this.action === 'create' ? null : this.selectedBusiness.contact
      }
    }
  },
  methods: {
    ...mapActions(['editBusiness', 'createBusiness']),
    formatRut (rut) {
      // XX.XXX.XXX-X
      const newRut = rut.replace(/\./g,'').replace(/\-/g, '').trim().toLowerCase()
      if (newRut.length >= 2) {
        const lastDigit = newRut.substr(-1, 1);
        const rutDigit = newRut.substr(0, newRut.length-1)
        let format = '';
        for (let i = 0; i < rutDigit.length; i++) {
          const e = rutDigit.charAt(rutDigit.length - i - 1);
          format = e.concat(format);
          if ((i + 1) % 3 === 0 && i+1 !== rutDigit.length){
            format = '.'.concat(format);
          }
        }
        this.form.rut = format.concat('-').concat(lastDigit);
      }
    },
    async onSubmit() {
      if(this.$v.$invalid || !this.rutIsValid || !this.contactIsValid) {
        this.$v.$touch();
      }else {
        const payload = this.form;
        const action = this.action === 'create' ? this.createBusiness : this.editBusiness;
        const response = await action(payload);
        
        if (response.status === 200 || response.status === 201) {
          this.makeToast("success", response.data.message, "Éxito!");
          this.hideModal();
        }else{
          this.makeToast("danger", response.data, "Ocurrió un error!");
        }
      }
    }
  },
  watch: {
    /**
     * Actualiza los email de contato separados por "," cada vez que cambian los tags de contacto
     */
    contactTags () {
      this.form.contact = this.contactTags.map(e => e.text.trim()).join(',')
    }
  },
  computed: {
    rutIsValid () {
      return validateRut(this.form.rut || '')
    },
    contactIsValid () {
      return validateRut(this.form.rut || '')
    },
  }
}
</script>